import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { StatsAndTestimonials } from './components/StatsAndTestimonials';
import { PainPoints } from './components/PainPoints';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { CostComparison } from './components/CostComparison';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
const PIXEL_ID = '904978025482552';
export function App() {
  useEffect(() => {
    // Exact Facebook Pixel base code
    if ((window as any).fbq) return;
    const f = window as any;
    const b = document;
    const e = 'script';
    const n: any = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    const t = b.createElement(e) as HTMLScriptElement;
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = b.getElementsByTagName(e)[0];
    s?.parentNode?.insertBefore(t, s);
    f.fbq('init', PIXEL_ID);
    f.fbq('track', 'PageView');
    // Add noscript pixel image fallback
    const noscriptImg = b.createElement('img');
    noscriptImg.height = 1;
    noscriptImg.width = 1;
    noscriptImg.style.display = 'none';
    noscriptImg.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
    b.body.appendChild(noscriptImg);
  }, []);
  return <div className="min-h-screen bg-background text-gray-300 font-body selection:bg-cyan selection:text-background" data-id="element-0">
      <Hero data-id="element-1" />
      <StatsAndTestimonials data-id="element-2" />
      <PainPoints data-id="element-3" />
      <Modules data-id="element-4" />
      <Bonuses data-id="element-5" />
      <Pricing data-id="element-6" />
      <CostComparison data-id="element-7" />
      <FinalCTA data-id="element-8" />
      <Footer data-id="element-9" />
      <PurchaseToast data-id="element-10" />
    </div>;
}